import { Module } from '@nestjs/common';
import { PersonasModule } from 'src/personas/personas.module';
import { winstonConfig } from '../common/logger/winston.config';
import { ClientesController } from './clientes.controller';
import { ClientesService } from './clientes.service';

@Module({
  controllers: [ClientesController],
  providers: [ClientesService],
  imports: [PersonasModule],
  exports: [ClientesService],
})
export class ClientesModule {}
